import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, CheckCircle2Icon } from 'lucide-react';
const bonuses = [{
  title: "Ebook Maestro 'Sculpt-It'",
  value: '$27',
  desc: 'El manual definitivo con el método 1-2-3.',
  img: 'https://cdn.magicpatterns.com/uploads/ekb4a2HzQmsbpYKThDegia/mk-1.png',
  isMain: true
}, {
  title: 'Bonus #1: Psicología del Color DIY',
  value: '$17',
  desc: 'Para que combine con tu pared.',
  img: 'https://cdn.magicpatterns.com/uploads/dyykN1qkkj8wndk3GAAXA7/bn-1.png'
}, {
  title: 'Bonus #2: Plantilla Gigante T-Rex',
  value: '$15',
  desc: "Para un efecto 'WOW' inmediato.",
  img: 'https://cdn.magicpatterns.com/uploads/n5r9nSAodVV2QHZqQFZHcS/bn-2.png'
}, {
  title: 'Bonus #3: Checklist de Ahorro 70%',
  value: '$7',
  desc: 'Materiales pro a precio de remate.',
  img: 'https://cdn.magicpatterns.com/uploads/jYnWviU258DXzn1TtL2rpf/bn-3.png'
}];
export function OfferSection() {
  return <section className="py-12 sm:py-24 px-4 bg-surface relative" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <div className="text-center mb-10 sm:mb-16" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-accent/10 border border-accent/20 text-accent px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-6" data-id="element-126">
            Lo que te llevas hoy
          </motion.div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-text mb-6" data-id="element-127">
            SISTEMA COMPLETO DE{' '}
            <span className="text-accent italic" data-id="element-128">DECORACIÓN PREMIUM</span>
          </h2>
          <p className="text-lg text-textMuted" data-id="element-129">
            Hoy no solo te llevas un Ebook. Te llevas el arsenal completo.
          </p>
        </div>

        <div className="space-y-6" data-id="element-130">
          {/* Main Product */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-background rounded-2xl border border-accent/30 overflow-hidden shadow-[0_0_30px_rgba(212,168,83,0.1)]" data-id="element-131">
            <div className="grid md:grid-cols-2 gap-5 sm:gap-8 p-5 sm:p-8 items-center" data-id="element-132">
              <div data-id="element-133">
                <img src={bonuses[0].img} alt={bonuses[0].title} loading="lazy" decoding="async" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-134" />
              </div>
              <div data-id="element-135">
                <div className="flex items-center gap-3 mb-4" data-id="element-136">
                  <CheckCircle2Icon className="w-6 h-6 text-accent" data-id="element-137" />
                  <h3 className="text-2xl font-serif text-text" data-id="element-138">
                    {bonuses[0].title}
                  </h3>
                </div>
                <p className="text-textMuted text-lg mb-4" data-id="element-139">{bonuses[0].desc}</p>
                <div className="inline-block bg-surfaceLight px-4 py-2 rounded-lg border border-white/10" data-id="element-140">
                  <span className="text-sm text-textMuted" data-id="element-141">Valor real: </span>
                  <span className="text-accent font-bold" data-id="element-142">
                    {bonuses[0].value}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Bonuses Grid */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-143">
            {bonuses.slice(1).map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-background rounded-2xl border border-white/10 overflow-hidden group hover:border-accent/30 transition-colors" data-id="element-144">
                <div className="h-48 overflow-hidden relative" data-id="element-145">
                  <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent z-10" data-id="element-146"></div>
                  <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-147" />
                </div>
                <div className="p-6 relative z-20 -mt-8" data-id="element-148">
                  <h4 className="font-serif text-lg text-text mb-2" data-id="element-149">
                    {bonus.title}
                  </h4>
                  <p className="text-sm text-textMuted mb-4" data-id="element-150">{bonus.desc}</p>
                  <div className="text-sm" data-id="element-151">
                    <span className="text-textMuted" data-id="element-152">Valor: </span>
                    <span className="text-accent font-medium" data-id="element-153">
                      {bonus.value}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Bonus 4 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-background rounded-2xl border border-white/10 overflow-hidden" data-id="element-154">
            <div className="grid sm:grid-cols-[240px_1fr] gap-0 items-center" data-id="element-155">
              <div className="h-48 sm:h-full overflow-hidden relative" data-id="element-156">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background/60 z-10 hidden sm:block" data-id="element-157"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent z-10 sm:hidden" data-id="element-158"></div>
                <img src="https://cdn.magicpatterns.com/uploads/dMYZ7Sm2GP3mcCrCLSwXce/BN-04.png" alt="Bonus #4: El Negocio del Papercraft" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-159" />
              </div>
              <div className="p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-4" data-id="element-160">
                <div className="text-center sm:text-left flex-grow" data-id="element-161">
                  <h4 className="font-serif text-xl text-text mb-2" data-id="element-162">
                    Bonus #4: El Negocio del Papercraft
                  </h4>
                  <p className="text-textMuted" data-id="element-163">
                    Cómo ganar tus primeros $500 vendiendo arte.
                  </p>
                </div>
                <div className="flex-shrink-0 text-center sm:text-right" data-id="element-164">
                  <span className="block text-sm text-textMuted" data-id="element-165">Valor:</span>
                  <span className="text-xl text-accent font-bold" data-id="element-166">$27</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Total Value Summary */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-12 text-center bg-surfaceLight border border-white/10 rounded-2xl p-8" data-id="element-167">
          <p className="text-lg text-textMuted mb-2 uppercase tracking-widest text-sm" data-id="element-168">
            Valor Total Acumulado
          </p>
          <p className="text-5xl font-serif text-text line-through opacity-50 decoration-danger decoration-4" data-id="element-169">
            $93 USD
          </p>
        </motion.div>
      </div>
    </section>;
}